import * as React from 'react';
import { IPromotion } from '../../../../types/builder/promotions';
import * as styles from './PromotionItem.css';
import { UIHeading4 } from '@cian/ui-kit';

interface IPromotionItem extends IPromotion {
  onClick: VoidFunction;
}

export const PromotionItem: React.FC<IPromotionItem> = ({ onClick, icon, title }) => {
  return (
    <li className={styles['promotion-item']} onClick={onClick}>
      <img src={icon} width={56} height={56} />
      <UIHeading4>{title}</UIHeading4>
    </li>
  );
};
